import { createSlice } from "@reduxjs/toolkit";
import { openAlert } from "../DataQualityStatus/DataQualitySlice";
import { fetchDownload } from "../DownloadManager/DownloadManagerSlice";

const initialState = {
  wsModule: "",
  isSocketOpen: false,
};


const WS_URL = `${process.env.REACT_APP_WS_URL}`;

export const WebSocketSlice = createSlice({
  name: "webSocket",
  initialState,
  reducers: {
    setWsString: (state, action) => {
      state.wsModule = action.payload;
    },
    setIsSocketOpen: (state, action) => {
      state.isSocketOpen = action.payload;
    },
  },
});

export const { setWsString, setIsSocketOpen } = WebSocketSlice.actions;

export const connectToWs = () => async (dispatch, getState) => {
  const state = getState();
  const isSocketOpen = state.webSocketReducer.isSocketOpen;

  if (isSocketOpen) return;

  const webSocket = new WebSocket(
    WS_URL
  );

  webSocket.onopen = () => {
    dispatch(setIsSocketOpen(true));
  };

  webSocket.onmessage = (event) => {
    const requestIds = JSON.parse(localStorage.getItem("requestIds")) || [];

    const requestIdObject = requestIds.find(
      (item) => item.requestId == JSON.parse(event.data).requestId
    );


    if (requestIdObject && JSON.parse(event.data).operation.status == "PROCESSING") {
      dispatch(
        openAlert({
          message: `The process you requested is being processed, check the download manager to verify its status.`,
          type: "info",
        })
      );  
      
      dispatch(fetchDownload(null, 0, 15));
    }

    if (requestIdObject && JSON.parse(event.data).operation.status == "SUCCESS") {
      dispatch(
        openAlert({
          message: `The file related to version ${requestIdObject.versionId} has been created, click on the banner to download it, or go to the download manager.`,
          type: "success",
          requestId:  requestIdObject.requestId,
          entityId: JSON.parse(event.data).entityId,
          clickable: true,
        })
      );  
      
      dispatch(fetchDownload(null, 0, 15));
    }

    if (requestIdObject && JSON.parse(event.data).operation.status == "COMPLETED") {
      dispatch(
        openAlert({
          message: `The process you requested has been completed, check the download manager to verify the possible generation of additional files.`,
          type: "success",
        })
      );  
      
      dispatch(fetchDownload(null, 0, 15));
    }

    if (requestIdObject && JSON.parse(event.data).operation.status == "READY_FOR_DOWNLOAD") {
      dispatch(
        openAlert({
          message: `The file related to requestId ${requestIdObject.requestId} has been created, click on the banner to download it, or go to the download manager.`,
          type: "success",
          requestId:  requestIdObject.requestId,
          entityId: JSON.parse(event.data).entityId,
          clickable: true,
        })
      );  
      
      dispatch(fetchDownload(null, 0, 15));
    }

    if (requestIdObject && JSON.parse(event.data).operation.status == "FAILED" ) {
      dispatch(
        openAlert({
          message: JSON.parse(event.data).description ? JSON.parse(event.data).description :  `Error during the creation of the file related to version ${requestIdObject.versionId}, please try again later.`,
          type: "danger",
        })
      );
    }
  };

  webSocket.onerror = () => {
    console.log("WebSocket connection error");
    dispatch(setIsSocketOpen(false));
  };

  webSocket.onclose = () => {
    console.log("WebSocket connection closed");
    dispatch(setIsSocketOpen(false));
  };

  return dispatch(setWsString("Ho aperto il webSocket!"));
};

export default WebSocketSlice.reducer;
